export default __webpack_public_path__ + "static/media/icon-advertise-cost.563916dc.svg";